"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { 
  if (!o[x]) {o[x] ={};} 
  return o[x] 
}, window);

// ─────────────────────────────────────────────
// FIELD INFO TOOLTIPS (ⓘ icon next to field label)
// ─────────────────────────────────────────────
var FIELD_INFO_MESSAGES = {
  'Thread':           'Select the thread color for your jeans.',
  'Denim Color':      'Select the denim color for your jeans.',
  'Waist':            'Select your waist size.',
  'Waist Size':       'Select your waist size.',
  'Inseam':           'Select your inseam length.',
  'Inseam Length':    'Select your inseam length.',
  'Hardware':         'Select the hardware finish for your jeans.',
  'Fit':              'Select your preferred fit.',
  'Length':           'Select the length of your garment.',
  'Rise':             'Select your preferred rise height.',
  'Style':            'Select the style of your garment.',
};

function addFieldInfoIcon(fieldElement, fieldName) {
  if (!fieldElement || typeof fieldElement.querySelector !== 'function') return;
  var message = FIELD_INFO_MESSAGES[fieldName];
  if (!message) return;
  if (fieldElement.querySelector('.io-field-info-icon')) return;

  var labelContainer = fieldElement.querySelector('.spb-label-tooltip')
                    || fieldElement.querySelector('label')
                    || fieldElement.querySelector('span');
  if (!labelContainer) return;

  var icon = document.createElement('span');
  icon.className = 'io-field-info-icon';
  icon.setAttribute('aria-label', message);
  icon.setAttribute('role', 'button');
  icon.setAttribute('tabindex', '0');
  icon.textContent = ' ⓘ';
  icon.style.cssText = [
    'display:inline-block',
    'cursor:pointer',
    'color:#888',
    'font-size:14px',
    'font-weight:normal',
    'vertical-align:middle',
    'margin-left:4px',
    'user-select:none',
    'position:relative',
    'transition:color 0.2s',
  ].join(';');

  var tooltip = document.createElement('span');
  tooltip.className = 'io-field-tooltip';
  tooltip.textContent = message;
  tooltip.style.cssText = [
    'position:absolute',
    'bottom:calc(100% + 8px)',
    'left:50%',
    'transform:translateX(-50%)',
    'background:#222',
    'color:#fff',
    'padding:7px 12px',
    'border-radius:5px',
    'font-size:12px',
    'pointer-events:none',
    'opacity:0',
    'visibility:hidden',
    'transition:opacity 0.2s, visibility 0.2s',
    'z-index:9999',
    'box-shadow:0 2px 8px rgba(0,0,0,0.18)',
    'width:100px',
    'white-space:normal',
    'text-align:center',
    'line-height:1.4',
  ].join(';');

  var arrow = document.createElement('span');
  arrow.style.cssText = [
    'position:absolute',
    'top:100%',
    'left:50%',
    'transform:translateX(-50%)',
    'border:5px solid transparent',
    'border-top-color:#222',
    'display:block',
    'width:0',
    'height:0',
  ].join(';');
  tooltip.appendChild(arrow);
  icon.style.position = 'relative';
  icon.appendChild(tooltip);

  var _tooltipVisible = false;
  function showTooltip() { tooltip.style.opacity='1'; tooltip.style.visibility='visible'; icon.style.color='#444'; _tooltipVisible=true; }
  function hideTooltip() { tooltip.style.opacity='0'; tooltip.style.visibility='hidden'; icon.style.color='#888'; _tooltipVisible=false; }

  icon.addEventListener('mouseenter', showTooltip);
  icon.addEventListener('mouseleave', hideTooltip);
  icon.addEventListener('click', function(e) {
    e.stopPropagation();
    if (_tooltipVisible) { hideTooltip(); } else {
      showTooltip();
      setTimeout(function() { if (_tooltipVisible) hideTooltip(); }, 3000);
    }
  });
  document.addEventListener('click', function(e) { if (!icon.contains(e.target)) hideTooltip(); });
  icon.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (_tooltipVisible) hideTooltip(); else showTooltip(); }
    if (e.key === 'Escape') hideTooltip();
  });

  labelContainer.appendChild(icon);
  console.log('ℹ️ Info icon added for field:', fieldName);
}

// ─────────────────────────────────────────────
// DENIM GALLERY FILTER
// ─────────────────────────────────────────────
var _originalThumbnails = null;
var _originalSlides     = null;
var _initialised        = false;

function captureOriginalGallery() {
  if (_initialised) return;
  var thumbList = document.querySelector('.thumbnail-list');
  var slideList = document.querySelector('.product__media-list');
  if (!thumbList || !slideList) return;

  _originalThumbnails = Array.prototype.map.call(
    thumbList.querySelectorAll('.thumbnail-list__item'),
    function(li) {
      var img = li.querySelector('img');
      return { li: li, mediaId: li.getAttribute('data-target') || '', imgSrc: img ? img.src.toLowerCase() : '', imgAlt: img ? (img.alt || '').toLowerCase() : '' };
    }
  );
  _originalSlides = Array.prototype.map.call(
    slideList.querySelectorAll('.product__media-item'),
    function(li) {
      var img = li.querySelector('img');
      return { li: li, mediaId: li.getAttribute('data-media-id') || '', imgSrc: img ? img.src.toLowerCase() : '', imgAlt: img ? (img.alt || '').toLowerCase() : '' };
    }
  );
  _initialised = true;
  console.log('📸 Gallery captured –', _originalThumbnails.length, 'thumbs,', _originalSlides.length, 'slides');
}

function getMatchingThumbnails(term) {
  var re = new RegExp(term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '[\\-_](\\d+)');
  var matches = [];
  _originalThumbnails.forEach(function(entry) {
    var hit = entry.imgSrc.match(re) || entry.imgAlt.match(re);
    if (hit) matches.push({ entry: entry, order: parseInt(hit[1], 10) });
  });
  matches.sort(function(a, b) { return a.order - b.order; });
  return matches.map(function(m) { return m.entry; });
}

function filterGalleryByDenim(term) {
  captureOriginalGallery();
  if (!_initialised) { console.warn('⚠️ Gallery not yet captured'); return; }
  console.log('🎯 Filtering gallery for:', term);
  var matchingThumbs = getMatchingThumbnails(term);
  if (matchingThumbs.length === 0) { showAllGalleryItems(); return; }

  var visibleIds = {};
  matchingThumbs.forEach(function(t) { visibleIds[t.mediaId] = true; });

  var thumbList = document.querySelector('.thumbnail-list');
  if (thumbList) {
    _originalThumbnails.forEach(function(t) { if (t.li.parentNode) t.li.parentNode.removeChild(t.li); });
    matchingThumbs.forEach(function(t, i) {
      t.li.style.display = '';
      thumbList.appendChild(t.li);
      var btn = t.li.querySelector('button.thumbnail');
      if (btn) { if (i === 0) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current'); }
    });
  }

  _originalSlides.forEach(function(s) {
    s.li.style.display = visibleIds[s.mediaId] ? '' : 'none';
    s.li.classList.remove('is-active');
  });

  var firstMediaId = matchingThumbs[0].mediaId;
  _originalSlides.forEach(function(s) { if (s.mediaId === firstMediaId) s.li.classList.add('is-active'); });

  var firstThumb = matchingThumbs[0].li.querySelector('button.thumbnail');
  if (firstThumb) firstThumb.click();

  var counterTotal = document.querySelector('.slider-counter--total');
  if (counterTotal) counterTotal.textContent = matchingThumbs.length;

  console.log('✅ Gallery filtered –', matchingThumbs.length, 'images visible');
}

function showAllGalleryItems() {
  if (!_initialised) return;
  var thumbList = document.querySelector('.thumbnail-list');
  if (thumbList) {
    _originalThumbnails.forEach(function(t, i) {
      t.li.style.display = '';
      thumbList.appendChild(t.li);
      var btn = t.li.querySelector('button.thumbnail');
      if (btn) { if (i === 0) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current'); }
    });
  }
  _originalSlides.forEach(function(s, i) { s.li.style.display = ''; s.li.classList.toggle('is-active', i === 0); });
  if (_originalThumbnails.length > 0) {
    var btn = _originalThumbnails[0].li.querySelector('button.thumbnail');
    if (btn) btn.click();
  }
  var counterTotal = document.querySelector('.slider-counter--total');
  if (counterTotal && _originalThumbnails.length) counterTotal.textContent = _originalThumbnails.length;
  console.log('↩️  Full gallery restored –', _originalThumbnails.length, 'images');
}

function getInitialDenimValue() {
  // 1. Leer desde URL params (?denim=dark-indigo o ?variant=...)
  var urlParams = new URLSearchParams(window.location.search);
  var urlDenim = urlParams.get('denim') || urlParams.get('Denim Color') || urlParams.get('denim_color');
  if (urlDenim) return urlDenim;

  // 2. Inferir desde el pathname del producto
  // /products/dark-indigo → "dark-indigo"
  // /products/striated-black → "striated-black"
  // /products/baggy-jeans → "sundance" (default)
  var pathname = window.location.pathname;
  var productSlug = pathname.split('/products/')[1];
  if (productSlug) {
    productSlug = productSlug.split('?')[0].split('/')[0];
    var SLUG_TO_DENIM = {
      'dark-indigo':     'Dark Indigo',
      'striated-black':  'Striated Black',
      'baggy-jeans':     'Sundance',
    };
    if (SLUG_TO_DENIM[productSlug]) return SLUG_TO_DENIM[productSlug];
  }

  // 3. Fallback: input hidden o radio checked
  var hiddenInputs = document.querySelectorAll('input[type="hidden"]');
  for (var i = 0; i < hiddenInputs.length; i++) {
    if ((hiddenInputs[i].name || '').toLowerCase().includes('denim')) return hiddenInputs[i].value || null;
  }
  var checked = document.querySelector('input[type="radio"]:checked, button[aria-pressed="true"]');
  if (checked) return checked.value || checked.textContent || null;

  return null;
}

// ─────────────────────────────────────────────
// SWATCH IMAGE MODAL
// Shared by Thread, Denim Color, and Hardware
// ─────────────────────────────────────────────

/**
 * Config per field: modal title and a zoom hint label.
 */
var SWATCH_MODAL_CONFIG = {
  'Thread':      { title: 'Thread Color',    hint: 'Click outside or press Esc to close' },
  'Denim Color': { title: 'Denim Color',     hint: 'Click outside or press Esc to close' },
  'Hardware':    { title: 'Hardware Finish', hint: 'Click outside or press Esc to close' },
};

/**
 * Extracts URL from a background-image CSS value.
 */
function extractBackgroundImageUrl(element) {
  if (!element) return null;
  var inlineStyle = element.getAttribute('style');
  if (inlineStyle && inlineStyle.indexOf('background-image') !== -1) {
    var m = inlineStyle.match(/background-image:\s*url\(['"]?([^'"()]+)['"]?\)/);
    if (m && m[1]) return m[1];
  }
  var bgImage = window.getComputedStyle(element).backgroundImage;
  if (!bgImage || bgImage === 'none') return null;
  var m2 = bgImage.match(/url\(['"]?([^'"()]+)['"]?\)/);
  return m2 ? m2[1] : null;
}

/**
 * Creates (once) the shared swatch modal DOM + styles.
 */
function createSwatchModal() {
  if (document.getElementById('swatch-modal')) return;

  var style = document.createElement('style');
  style.textContent = [
    '#swatch-modal{display:none;position:fixed;inset:0;z-index:10000;animation:swatchFadeIn 0.18s ease-out}',
    '#swatch-modal.active{display:flex;align-items:center;justify-content:center}',
    '.swatch-modal-overlay{position:absolute;inset:0;background:rgba(0,0,0,0.82);cursor:pointer}',
    '.swatch-modal-box{',
      'position:relative;z-index:1;',
      'background:#fff;',
      'border-radius:10px;',
      'padding:0;',
      'max-width:520px;width:calc(100% - 40px);',
      'box-shadow:0 24px 64px rgba(0,0,0,0.45);',
      'animation:swatchSlideUp 0.22s ease-out;',
      'overflow:hidden;',
    '}',
    '.swatch-modal-header{',
      'display:flex;align-items:center;justify-content:space-between;',
      'padding:14px 18px 12px;',
      'border-bottom:1px solid rgba(0,0,0,0.08);',
    '}',
    '.swatch-modal-title{margin:0;font-size:14px;font-weight:600;letter-spacing:0.03em;color:#1a1a1a;}',
    '.swatch-modal-hint{font-size:11px;color:#aaa;margin:0;}',
    '.swatch-modal-close{',
      'background:transparent;border:none;cursor:pointer;',
      'width:32px;height:32px;border-radius:50%;',
      'display:flex;align-items:center;justify-content:center;',
      'font-size:20px;color:#666;line-height:1;',
      'transition:background 0.15s,color 0.15s;flex-shrink:0;',
    '}',
    '.swatch-modal-close:hover{background:#f0f0f0;color:#111;}',
    '.swatch-modal-img-wrap{',
      'display:flex;align-items:center;justify-content:center;',
      'background:#f7f5f2;',
      'min-height:260px;max-height:60vh;',
      'padding:0;',
    '}',
    '.swatch-modal-img{',
      'width:100%;height:100%;',
      'max-height:60vh;',
      'object-fit:contain;',
      'display:block;',
    '}',
    '@keyframes swatchFadeIn{from{opacity:0}to{opacity:1}}',
    '@keyframes swatchSlideUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}',
    // Mobile
    '@media(max-width:600px){',
      '.swatch-modal-box{max-width:100%;width:calc(100% - 24px);}',
      '.swatch-modal-img-wrap{min-height:200px;}',
    '}',
  ].join('');
  document.head.appendChild(style);

  var modal = document.createElement('div');
  modal.id = 'swatch-modal';
  modal.innerHTML = [
    '<div class="swatch-modal-overlay"></div>',
    '<div class="swatch-modal-box" role="dialog" aria-modal="true" aria-label="Swatch preview">',
      '<div class="swatch-modal-header">',
        '<h2 class="swatch-modal-title"></h2>',
        '<button class="swatch-modal-close" aria-label="Close">&times;</button>',
      '</div>',
      '<div class="swatch-modal-img-wrap">',
        '<img class="swatch-modal-img" src="" alt="">',
      '</div>',
    '</div>',
  ].join('');
  document.body.appendChild(modal);

  // Close handlers
  modal.querySelector('.swatch-modal-overlay').addEventListener('click', closeSwatchModal);
  modal.querySelector('.swatch-modal-close').addEventListener('click', closeSwatchModal);
  document.addEventListener('keydown', function(e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && modal.classList.contains('active')) closeSwatchModal();
  });

  console.log('✅ Swatch modal created');
}

/**
 * Opens the shared modal with the given image and field config.
 * @param {string} imageSrc
 * @param {string} fieldName  – 'Thread' | 'Denim Color' | 'Hardware'
 * @param {string} optionLabel – the swatch label/value shown as subtitle
 */
function openSwatchModal(imageSrc, fieldName, optionLabel) {
  if (!imageSrc) return;
  createSwatchModal();

  var modal  = document.getElementById('swatch-modal');
  var config = SWATCH_MODAL_CONFIG[fieldName] || { title: fieldName, hint: 'Press Esc to close' };

  var finalSrc = imageSrc.startsWith('//') ? 'https:' + imageSrc : imageSrc;

  // Populate
  modal.querySelector('.swatch-modal-title').textContent = optionLabel
    ? config.title + ' — ' + optionLabel
    : config.title;

  var img = modal.querySelector('.swatch-modal-img');
  img.src = finalSrc;
  img.alt = optionLabel || config.title;

  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  console.log('✅ Swatch modal opened:', fieldName, '|', optionLabel, '|', finalSrc);
}

function closeSwatchModal() {
  var modal = document.getElementById('swatch-modal');
  if (modal) modal.classList.remove('active');
  document.body.style.overflow = '';
}

// ─────────────────────────────────────────────
// ATTACH SWATCH CLICK LISTENERS
// Works for Thread, Denim Color, and Hardware
// ─────────────────────────────────────────────

// ─────────────────────────────────────────────
// DENIM COLOR → PRODUCT URL MAP
// ─────────────────────────────────────────────
var DENIM_PRODUCT_URLS = {
  'dark indigo':     'https://lemonstreetdenim.com/products/dark-indigo',
  'sundance':        'https://lemonstreetdenim.com/products/baggy-jeans',
  'striated black':  'https://lemonstreetdenim.com/products/striated-black',
};

/**
 * Attaches click-to-zoom listeners on every image-backed swatch
 * inside the given field element.
 *
 * @param {HTMLElement} fieldElement
 * @param {string}      fieldName
 */
function attachSwatchClickListeners(fieldElement, fieldName) {
  if (!fieldElement) return;

  // If Denim Color → redirect to product page instead of opening modal
  if (fieldName === 'Denim Color') {
    setTimeout(function() {
      var labels = fieldElement.querySelectorAll('label.spb-productoptionswatchwrapper');
      labels.forEach(function(label) {
        if (label.dataset.swatchRedirectBound === 'true') return;
        label.dataset.swatchRedirectBound = 'true';

        var input = label.querySelector('input');
        if (!input) return;

        label.addEventListener('click', function() {
          var value = (input.value || '').toLowerCase().trim();
          var url = DENIM_PRODUCT_URLS[value];
          if (url) {
            // Don't redirect if we're already on the correct product page
            var currentPath = window.location.pathname.toLowerCase();
            var targetPath = new URL(url).pathname.toLowerCase();
            if (currentPath === targetPath) return;

            setTimeout(function() {
              window.location.href = url;
            }, 80);
          }
        });
      });
      console.log('✅ Denim Color swatches set to redirect');
    }, 500);
    return; // Skip modal logic for Denim Color
  }

  // Thread and Hardware → original behavior (open swatch modal)
  console.log('🔍 Attaching swatch click listeners for:', fieldName);
  setTimeout(function() {
    var labels = fieldElement.querySelectorAll('label.spb-productoptionswatchwrapper');
    labels.forEach(function(label) {
      if (label.dataset.swatchModalBound === 'true') return;
      var swatch = label.querySelector('.spb-productoptionswatch');
      if (!swatch) return;
      var imageUrl = extractBackgroundImageUrl(swatch);
      if (!imageUrl) return; // Skip solid-colour swatches (no image)
      var optionLabel = (
        label.querySelector('.spb-swatch-name')
        || label.querySelector('span:not(.spb-productoptionswatch)')
        || label
      ).textContent.trim();
      label.dataset.swatchModalBound = 'true';
      label.style.cursor  = 'pointer';
      swatch.style.cursor = 'pointer';
      // Open modal after short delay so the radio input is selected first
      label.addEventListener('click', function() {
        setTimeout(function() {
          openSwatchModal(imageUrl, fieldName, optionLabel);
        }, 80);
      });
    });
    console.log('✅ Swatch listeners attached for:', fieldName);
  }, 500);
}

// ─────────────────────────────────────────────
// TOOLTIP HELPERS
// ─────────────────────────────────────────────
function addTooltipsToOptions(fieldElement, fieldName) {
  if (!fieldElement || typeof fieldElement.querySelectorAll !== 'function') return;
  setTimeout(function() {
    var inputs = fieldElement.querySelectorAll('input[type="radio"], input[type="checkbox"], select, button, label');
    inputs.forEach(function(input) {
      var optionValue = input.value || input.textContent || input.getAttribute('data-value') || input.getAttribute('title');
      if (!optionValue) return;
      var wrapper = (input.closest ? input.closest('label') : null) || input.parentElement;
      if (!wrapper || wrapper.querySelector('.io-tooltip')) return;
      wrapper.style.position = 'relative';
      var tooltip = document.createElement('span');
      tooltip.className = 'io-tooltip';
      tooltip.textContent = optionValue.trim();
      tooltip.style.cssText = 'position:absolute;bottom:100%;left:50%;transform:translateX(-50%) translateY(-8px);background:#333;color:#fff;padding:6px 12px;border-radius:4px;font-size:12px;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden;transition:all 0.2s;z-index:1000;';
      wrapper.appendChild(tooltip);
      wrapper.addEventListener('mouseenter', function() { tooltip.style.opacity='1'; tooltip.style.visibility='visible'; });
      wrapper.addEventListener('mouseleave', function() { tooltip.style.opacity='0'; tooltip.style.visibility='hidden'; });
    });
  }, 500);
}

// ─────────────────────────────────────────────
// SIZE GUIDE HELPER
// ─────────────────────────────────────────────
function moveSizeGuideToInseam(inseamFieldElement) {
  if (!inseamFieldElement) return;
  setTimeout(function() {
    var sizeGuideElement = document.querySelector('modal-opener[data-modal="#PopupModal-popup_PgkDn9"]');
    if (!sizeGuideElement) return;
    if (sizeGuideElement.dataset.moved === 'true') return;

    sizeGuideElement.classList.remove('quick-add-hidden');
    sizeGuideElement.style.cssText = 'display:inline-block;cursor:pointer;vertical-align:middle;';
    sizeGuideElement.dataset.moved = 'true';

    var labelRow = inseamFieldElement.querySelector('.spb-label-tooltip');
    if (labelRow) {
      var wrapper = document.createElement('span');
      wrapper.style.cssText = 'margin-left:auto;';
      wrapper.appendChild(sizeGuideElement);
      labelRow.appendChild(wrapper);
      console.log('✅ Size Guide moved into Inseam label row');
    }
  }, 1200);
}

// ─────────────────────────────────────────────
// HOW TO MEASURE
// ─────────────────────────────────────────────
function moveHowToMeasureToWaist(waistFieldElement) {
  if (!waistFieldElement) return;
  setTimeout(function() {
    // Target the modal-opener wrapper, not just the button
    var howToMeasureElement = document.querySelector('modal-opener[data-modal="#PopupModal-popup_zttkK3"]');
    if (!howToMeasureElement) return;
    if (howToMeasureElement.dataset.moved === 'true') return;

    howToMeasureElement.style.cssText = 'display:inline-block;cursor:pointer;vertical-align:middle;';
    howToMeasureElement.dataset.moved = 'true';

    var labelRow = waistFieldElement.querySelector('.spb-label-tooltip');
    if (labelRow) {
      labelRow.style.display    = 'flex';
      labelRow.style.alignItems = 'center';
      var wrapper = document.createElement('span');
      wrapper.style.cssText = 'margin-left:auto;';
      wrapper.appendChild(howToMeasureElement);
      labelRow.appendChild(wrapper);
      console.log('✅ How to Measure moved into Waist label row');
    }
  }, 1000);
}

// ─────────────────────────────────────────────
// SHOW ALL THREAD / SHOW ALL HARDWARE LINKS
// Moves the existing popup-opener links so they
// appear flush-right on the same row as the
// field label — identical to Size Guide on Waist.
//
// The links are already in the DOM (added via
// Shopify theme editor as popup blocks).  We just
// re-parent them into the IO label wrapper.
//
// HOW TO UPDATE the selectors:
//   Open the product page, inspect the "Show all
//   thread" anchor/button, copy its data-modal or
//   class value and update SHOW_ALL_THREAD_SELECTOR
//   (and the hardware equivalent) below.
// ─────────────────────────────────────────────

/**
 * CSS selector that matches the "Show all thread" popup opener.
 * Update the data-modal value to match your actual popup ID.
 */
var SHOW_ALL_THREAD_SELECTOR   = '[data-modal*="#PopupModal-popup_zftxFR"], [href*="thread"], .show-all-thread, modal-opener:has([data-label*="thread" i]), modal-opener:has([data-label*="Thread"])';

/**
 * CSS selector that matches the "Show all hardware" popup opener.
 * Update the data-modal value to match your actual popup ID.
 */
var SHOW_ALL_HARDWARE_SELECTOR = '[data-modal*="#PopupModal-popup_rMwmTR"], [href*="hardware"], .show-all-hardware, modal-opener:has([data-label*="hardware" i]), modal-opener:has([data-label*="Hardware"])';

/**
 * CSS selector that matches the "Show all denim" popup opener.
 * Update the data-modal value to match your actual popup ID.
 */
var SHOW_ALL_DENIM_SELECTOR    = '[data-modal*="#PopupModal-popup_RVUJTa"], [href*="denim"], .show-all-denim, modal-opener:has([data-label*="denim" i]), modal-opener:has([data-label*="Denim"])';

/**
 * Generic helper: finds a popup-opener element by selector and moves
 * it into the IO field's label row, right-aligned (same pattern as
 * moveSizeGuideToWaist).
 *
 * @param {HTMLElement} fieldElement  – the IO field wrapper
 * @param {string}      selector      – CSS selector for the link/button
 * @param {string}      debugName     – label for console messages
 */
function movePopupLinkToFieldLabel(fieldElement, selector, debugName) {
  if (!fieldElement) return;

  setTimeout(function() {
    // Try each comma-separated part of the selector individually so
    // browsers that don't support :has() still find simple selectors.
    var linkElement = null;
    var parts = selector.split(',');
    for (var i = 0; i < parts.length; i++) {
      try {
        linkElement = document.querySelector(parts[i].trim());
        if (linkElement) break;
      } catch(e) { /* :has() unsupported – skip */ }
    }

    if (!linkElement) {
      console.log('⚠️ ' + debugName + ' link not found in DOM – skipping');
      return;
    }
    if (linkElement.dataset.movedToLabel === 'true') return;

    // Style the link to match Size Guide appearance
    linkElement.style.cssText = 'display:inline-block;margin-left:auto;cursor:pointer;vertical-align:middle;font-size:inherit;';
    linkElement.dataset.movedToLabel = 'true';

    // IO field label row: .spb-label-tooltip wraps both the label text
    // and any appended controls (ⓘ icon, Size Guide, etc.)
    var labelRow = fieldElement.querySelector('.spb-label-tooltip');
    if (labelRow) {
      // Make the row flex so the link snaps to the right edge
      labelRow.style.display     = labelRow.style.display || 'flex';
      labelRow.style.alignItems  = 'center';
      labelRow.style.flexWrap    = 'wrap';
      labelRow.style.columnGap   = '8px';
      labelRow.style.marginLeft  = 'auto'; // push the link right
      // Re-style just the link wrapper
      var linkWrapper = document.createElement('span');
      linkWrapper.style.cssText = 'margin-left:auto;';
      linkWrapper.appendChild(linkElement);
      labelRow.appendChild(linkWrapper);
      console.log('✅ ' + debugName + ' link moved into label row');
    } else {
      console.log('⚠️ .spb-label-tooltip not found for ' + debugName);
    }
  }, 1200);
}

function moveShowAllThreadLink(threadFieldElement) {
  movePopupLinkToFieldLabel(threadFieldElement, SHOW_ALL_THREAD_SELECTOR, 'Show all thread');
}

function moveShowAllHardwareLink(hardwareFieldElement) {
  movePopupLinkToFieldLabel(hardwareFieldElement, SHOW_ALL_HARDWARE_SELECTOR, 'Show all hardware');
}

function moveShowAllDenimLink(denimFieldElement) {
  movePopupLinkToFieldLabel(denimFieldElement, SHOW_ALL_DENIM_SELECTOR, 'Show all denim');
}

// ─────────────────────────────────────────────
// ERROR / SCROLL HELPERS
// ─────────────────────────────────────────────
function showFieldError(fieldElement, errorMessage) {
  if (!fieldElement || typeof fieldElement.querySelector !== 'function') return;
  clearFieldError(fieldElement);
  var errorDiv = document.createElement('div');
  errorDiv.className = 'infinite-options-error';
  errorDiv.style.cssText = 'color:#d32f2f;font-size:12px;text-align:left;margin-top:8px;';
  errorDiv.textContent = errorMessage;
  fieldElement.appendChild(errorDiv);
}

function clearFieldError(fieldElement) {
  if (!fieldElement || typeof fieldElement.querySelector !== 'function') return;
  var existingError = fieldElement.querySelector('.infinite-options-error');
  if (existingError) existingError.remove();
  fieldElement.style.backgroundColor = '';
}

function scrollToField(fieldElement) {
  if (!fieldElement || typeof fieldElement.getBoundingClientRect !== 'function') return;
  var elementTop = fieldElement.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({ top: elementTop - 100, behavior: 'smooth' });
  fieldElement.style.transition = 'background-color 0.3s';
  fieldElement.style.backgroundColor = '#fff3e0';
  setTimeout(function() { fieldElement.style.backgroundColor = ''; }, 1000);
}

// ─────────────────────────────────────────────
// LIVE SELECTIONS SUMMARY
// Shows chosen Denim, Thread, Hardware (+ any
// other tracked field) in a compact badge strip
// below the IO form, updating on every change.
// ─────────────────────────────────────────────

/**
 * Fields to track and the label shown in the summary.
 * Order here = display order in the strip.
 * Add / remove entries to customise which fields appear.
 */
var SUMMARY_FIELDS = [
  { name: 'Denim Color', label: 'Denim'    },
  { name: 'Thread',      label: 'Thread'   },
  { name: 'Hardware',    label: 'Hardware' },
];

/** Live state – populated by fieldLoad + fieldChange */
var _summaryState = {};

/** Inject the summary strip once into the page */
function createSelectionsSummary() {
  if (document.getElementById('io-selections-summary')) return;

  // ── Styles ──
  var style = document.createElement('style');
  style.textContent = [
    '#io-selections-summary{',
      'display:flex;',
      'flex-wrap:wrap;',
      'gap:1rem;',
      'padding:12px 16px;',
      'margin:0 0 16px;',
      'background:#f7f5f2;',
      'border:1px solid rgba(0,0,0,0.08);',
      'border-radius:8px;',
      'font-size:13px;',
      'line-height:1.4;',
      'transition:opacity 0.25s;',
      'flex-direction:column;',
      'align-items:flex-start;',
    '}',
    '#io-selections-summary.io-sum-hidden{opacity:0;pointer-events:none;}',
    '#io-sum-title{',
      'width:100%;',
      'font-weight:700;',
      'letter-spacing:0.08em;',
      'text-transform:uppercase;',
      'color:#1a1a1a;',
      'margin:0 0 8px 0;',
    '}',
    '.io-sum-label{',
      'font-size:11px;',
      'font-weight:700;',
      'letter-spacing:0.07em;',
      'text-transform:uppercase;',
      'white-space:nowrap;',
      'margin-right:2px;',
    '}',
    '.io-sum-badge{',
      'display:inline-flex;',
      'align-items:center;',
      'gap:6px;',
      'background:#fff;',
      'border:1px solid rgba(0,0,0,0.11);',
      'border-radius:20px;',
      'padding:4px 11px 4px 8px;',
      'font-size:12.5px;',
      'font-weight:500;',
      'color:#1a1a1a;',
      'white-space:nowrap;',
      'transition:all 0.18s ease;',
    '}',
    '.io-sum-badge.io-sum-empty{',
      'color:#bbb;',
      'border-style:dashed;',
      'font-weight:400;',
    '}',
    '.io-sum-swatch{',
      'width:12px;height:12px;',
      'border-radius:50%;',
      'border:1px solid rgba(0,0,0,0.12);',
      'flex-shrink:0;',
      'background-size:cover;',
      'background-position:center;',
    '}',
    '#io-sum-badges-row{',
      'display:flex;',
      'gap:.5rem;',
      'align-items:center',
    '}',
    // Animate badge value when it changes
    '@keyframes ioSumPop{0%{transform:scale(0.92);opacity:0.6}100%{transform:scale(1);opacity:1}}',
    '.io-sum-badge.io-sum-pop{animation:ioSumPop 0.2s ease-out;}',
  ].join('');
  document.head.appendChild(style);

  // ── Markup ──
  var wrap = document.createElement('div');
  wrap.id = 'io-selections-summary';
  wrap.setAttribute('aria-live', 'polite');
  wrap.setAttribute('aria-label', 'Your current selections');

  var IO_SUMMARY_TITLE = 'Your Design';

  var title = document.createElement('p');
  title.id = 'io-sum-title';
  title.textContent = IO_SUMMARY_TITLE;
  wrap.appendChild(title);

  // ── Fila de badges en una sola línea ──
  
  SUMMARY_FIELDS.forEach(function(field, i) {
    var badgesRow = document.createElement('div');
    badgesRow.id = 'io-sum-badges-row';
    wrap.appendChild(badgesRow);

    var label = document.createElement('span');
    label.className = 'io-sum-label';
    label.textContent = field.label + ':';
    badgesRow.appendChild(label);

    var badge = document.createElement('span');
    badge.className = 'io-sum-badge io-sum-empty';
    badge.id = 'io-sum-badge-' + field.name.replace(/\s+/g, '-');
    badge.textContent = '—';
    badgesRow.appendChild(badge);
  });

  // ── Inject below the IO form ──
  // IO wraps its output in a <div id="infiniteoptions-container"> or similar;
  // we try several selectors and fall back to appending before the Add-to-cart button.
  var anchor = document.querySelector('#infiniteoptions-container')
             || document.querySelector('.product-form__input--no-variants')
             || document.querySelector('.product-form')
             || document.querySelector('product-form')
             || document.querySelector('form[action="/cart/add"]');

  if (anchor) {
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    console.log('✅ Selections summary injected');
  } else {
    console.warn('⚠️ Could not find IO container anchor – summary not injected');
  }
}

/**
 * Updates a single badge inside the summary strip.
 * @param {string} fieldName   – must match a SUMMARY_FIELDS entry
 * @param {string} value       – chosen option text
 * @param {string} [swatchUrl] – optional swatch image URL for a colour dot
 * @param {string} [swatchBg]  – optional solid CSS colour for the dot
 */
function updateSummaryBadge(fieldName, value, swatchUrl, swatchBg) {
  var badge = document.getElementById('io-sum-badge-' + fieldName.replace(/\s+/g, '-'));
  if (!badge) return;

  // Clear
  badge.innerHTML = '';
  badge.classList.remove('io-sum-empty', 'io-sum-pop');

  if (!value || value === '—') {
    badge.className = 'io-sum-badge io-sum-empty';
    badge.textContent = '—';
    return;
  }

  // Swatch dot (image or solid colour)
  if (swatchUrl || swatchBg) {
    var dot = document.createElement('span');
    dot.className = 'io-sum-swatch';
    if (swatchUrl) {
      var finalUrl = swatchUrl.startsWith('//') ? 'https:' + swatchUrl : swatchUrl;
      dot.style.backgroundImage = 'url(' + finalUrl + ')';
    } else {
      dot.style.background = swatchBg;
    }
    badge.appendChild(dot);
  }

  var text = document.createElement('span');
  text.textContent = value;
  badge.appendChild(text);

  badge.className = 'io-sum-badge';

  // Pop animation on change
  void badge.offsetWidth; // force reflow
  badge.classList.add('io-sum-pop');
  setTimeout(function() { badge.classList.remove('io-sum-pop'); }, 220);

  console.log('🏷️ Summary badge updated:', fieldName, '→', value);
}

/**
 * Reads the swatch image URL or background colour for a chosen option.
 * Called after fieldChange to get the visual for the selected swatch.
 *
 * @param {HTMLElement} fieldElement
 * @param {string}      value   – the chosen value text
 * @returns {{ url: string|null, bg: string|null }}
 */
function getSwatchStyleForValue(fieldElement, value) {
  if (!fieldElement) return { url: null, bg: null };

  // Find the label whose input value or text matches the chosen value
  var labels = fieldElement.querySelectorAll('label.spb-productoptionswatchwrapper');
  for (var i = 0; i < labels.length; i++) {
    var label = labels[i];
    var input = label.querySelector('input');
    var labelText = label.textContent.trim();
    var inputVal  = input ? input.value : '';

    if (inputVal === value || labelText === value) {
      var swatch = label.querySelector('.spb-productoptionswatch');
      if (!swatch) continue;

      var imgUrl = extractBackgroundImageUrl(swatch);
      if (imgUrl) return { url: imgUrl, bg: null };

      // Solid colour fallback
      var bg = window.getComputedStyle(swatch).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        return { url: null, bg: bg };
      }
    }
  }
  return { url: null, bg: null };
}

// ─────────────────────────────────────────────
// INFINITE OPTIONS HOOKS
// ─────────────────────────────────────────────
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {

  // ── fieldLoad ──────────────────────────────
  subscribe('fieldLoad', function(event) {
    var fieldName = event.detail.name;
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('🔍 FIELD LOAD –', fieldName);

    var element = event.detail.element;
    if (element && element.jquery) element = element[0] || element.get(0);

    if (element && element.nodeType) {
      addFieldInfoIcon(element, fieldName);
      addTooltipsToOptions(element, fieldName);

      if (fieldName === 'Waist' || fieldName === 'Waist Size') {
        moveHowToMeasureToWaist(element);  
      }

      if (fieldName === 'Inseam' || fieldName === 'Inseam Length' || fieldName === 'inseam') {
        moveSizeGuideToInseam(element);   
      }

      // Attach swatch modal for Thread, Denim Color, and Hardware
      if (fieldName === 'Thread' || fieldName === 'Denim Color' || fieldName === 'Hardware') {
        attachSwatchClickListeners(element, fieldName);
      }

      // Move "Show all thread / hardware" popup links into their label rows
      if (fieldName === 'Thread') {
        moveShowAllThreadLink(element);
      }
      if (fieldName === 'Hardware') {
        moveShowAllHardwareLink(element);
      }
      if (fieldName === 'Denim Color') {
        moveShowAllDenimLink(element);
      }
    }

    // ── SELECTIONS SUMMARY: inject strip + seed initial value ──
    var trackedNames = SUMMARY_FIELDS.map(function(f) { return f.name; });
    if (trackedNames.indexOf(fieldName) !== -1) {
      createSelectionsSummary();

      // Seed badge with pre-selected value (IO may auto-select first option)
      var capturedElement = element;
      setTimeout(function() {
        var preSelected = null;

        if (capturedElement) {
          var checkedInput = capturedElement.querySelector('input[type="radio"]:checked, button[aria-pressed="true"]');
          if (checkedInput) preSelected = checkedInput.value || checkedInput.getAttribute('data-value');
          if (!preSelected) {
            var hidden = capturedElement.querySelector('input[type="hidden"]');
            if (hidden && hidden.value) preSelected = hidden.value;
          }
        }

        if (preSelected) {
          _summaryState[fieldName] = preSelected;
          var swatchStyle = getSwatchStyleForValue(capturedElement, preSelected);
          updateSummaryBadge(fieldName, preSelected, swatchStyle.url, swatchStyle.bg);
        }
      }, 750);
    }

    // Initial denim gallery filter on page load
    if (fieldName === 'Denim Color') {
      setTimeout(function() {
        var val = getInitialDenimValue();
        if (val) {
          console.log('🎨 Initial Denim Color detected:', val);

          // Pre-seleccionar el radio en el IO form
          if (element) {
            var radios = element.querySelectorAll('input[type="radio"]');
            radios.forEach(function(radio) {
              if (radio.value === val) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });

            // Para swatches tipo button
            var buttons = element.querySelectorAll('button[data-value], label.spb-productoptionswatchwrapper');
            buttons.forEach(function(btn) {
              var btnVal = btn.getAttribute('data-value') || btn.querySelector('input') && btn.querySelector('input').value;
              if (btnVal === val) btn.click();
            });
          }

          filterGalleryByDenim(val.toLowerCase().replace(/\s+/g, '-'));
        }
      }, 600);
    }

    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  });

  // ── fieldChange ────────────────────────────
  subscribe('fieldChange', function(event) {
    var fieldName  = event.detail.name;
    var fieldValue = event.detail.value;
    console.log('🔔 Field changed:', fieldName, '→', fieldValue);

    var element = event.detail.element;
    if (element && element.jquery) element = element[0] || element.get(0);
    if (element && typeof element.closest === 'function') {
      var errorContainer = element.closest('span');
      if (errorContainer) clearFieldError(errorContainer);
    }

    if (fieldName === 'Denim Color') {
      filterGalleryByDenim(fieldValue.toLowerCase().replace(/\s+/g, '-'));
    }

    // ── SELECTIONS SUMMARY: update badge live on every change ──
    var trackedNames = SUMMARY_FIELDS.map(function(f) { return f.name; });
    if (trackedNames.indexOf(fieldName) !== -1 && fieldValue) {
      _summaryState[fieldName] = fieldValue;
      var swatchStyle = getSwatchStyleForValue(element, fieldValue);
      updateSummaryBadge(fieldName, fieldValue, swatchStyle.url, swatchStyle.bg);
    }
  });

  // ── appLoad ────────────────────────────────
  subscribe('appLoad', function(event) {
    console.log('🚀 Infinite Options loaded');
    setTimeout(function() { captureOriginalGallery(); }, 800);
  });

  // ── validationFail ─────────────────────────
  subscribe('validationFail', function(event) {
    console.log('⚠️ Validation failed:', event.detail.error);
    event.preventDefault();
    var element = event.detail.element;
    if (element && element.jquery) element = element[0] || element.get(0);
    if (element && typeof element.closest === 'function') {
      var errorContainer = element.closest('span');
      if (errorContainer) {
        showFieldError(errorContainer, event.detail.error);
        scrollToField(errorContainer);
      }
    }
  });
};